import { Liquid } from "liquidjs"
const liquidjs = new Liquid()

/**
 * Helepr to make highlight syntax in vs code
 * It accepts a string and returns the same string interpolated
 * No magic here, mostly just helper for VS code syntax highliting for GraphQL
 * @param {*} literals
 * @param  {...any} expressions
 */
const gql = (literals, ...expressions) => {
	let string = ``
	for (const [i, val] of expressions.entries()) {
		string += literals[i] + val
	}
	string += literals[literals.length - 1]
	return string
}

/**
 * Helper to parse liquid html into AST
 */
const parseLiquid = htmlString => {
	return liquidjs.parse(htmlString)
}

export { gql, parseLiquid }
